<div class="space-y-3">
  <!-- Input oculto reutilizable para reemplazar un documento (Incidente #27) -->
  <input #replaceInput type="file" class="hidden"
         accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.webp"
         (change)="onDocumentoSeleccionado($event)" [disabled]="uploadingDoc" />

  <!-- Header row: title, filter, add + upload buttons -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <div class="flex items-center gap-2">
      <h4 class="text-sm font-semibold text-gray-600 dark:text-gray-300">Adjuntos</h4>
      @if (attachments.length > 0) {
        <span class="text-xs text-gray-400 dark:text-gray-500">({{ attachments.length }})</span>
      }
    </div>
    <div class="flex items-center gap-2">
      <!-- Filter by type -->
      <select
        [(ngModel)]="filterType"
        (ngModelChange)="cambiarFiltro()"
        class="px-2 py-1 text-xs border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300">
        <option [ngValue]="undefined">Todos los tipos</option>
        <option value="image">Imagenes</option>
        <option value="document">Documentos</option>
        <option value="video">Videos</option>
        <option value="other">Otros</option>
      </select>
      <!-- Subir documento desde el PC -->
      <label class="cursor-pointer px-2.5 py-1 text-xs rounded-md font-medium bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600 flex items-center gap-1"
             [class.opacity-50]="uploadingDoc">
        {{ uploadingDoc ? 'Subiendo...' : 'Subir documento' }}
        <input type="file" class="hidden"
               accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.webp"
               (change)="onDocumentoSeleccionado($event)" [disabled]="uploadingDoc" />
      </label>
      <!-- Add button (adjunto por URL: imagen/video/enlace) -->
      @if (!showForm) {
        <button type="button" (click)="abrirFormNuevo()"
          class="px-2.5 py-1 text-xs rounded-md font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
          </svg>
          Añadir por URL
        </button>
      }
    </div>
  </div>
  <p class="text-xs text-gray-400 dark:text-gray-500">Documentos: PDF, Word, Excel, imágenes (JPG/PNG/WEBP). También puede añadir adjuntos por URL (imagen/video/enlace).</p>
  @if (docError) {
    <p class="text-xs text-error-500">{{ docError }}</p>
  }

  <!-- Error -->
  @if (error) {
    <p class="text-xs text-error-500 dark:text-error-400">{{ error }}</p>
  }

  <!-- Inline form for create/edit -->
  @if (showForm) {
    <div class="border border-brand-200 dark:border-brand-800/40 rounded-lg p-3 bg-brand-50/40 dark:bg-brand-900/10 space-y-3">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-brand-600 dark:text-brand-400">
          {{ editingId !== null ? 'Editar adjunto' : 'Nuevo adjunto' }}
        </span>
        <button type="button" (click)="cerrarForm()" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-2">
        <!-- Row 1: Type + URL -->
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
          <div>
            <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">Tipo <span class="text-error-500">*</span></label>
            <select formControlName="attachmentType"
              class="w-full px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              <option value="image">Imagen</option>
              <option value="document">Documento</option>
              <option value="video">Video</option>
              <option value="other">Otro</option>
            </select>
          </div>
          <div class="sm:col-span-2">
            <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">URL del archivo <span class="text-error-500">*</span></label>
            <input type="text" formControlName="fileUrl" placeholder="https://cdn.ejemplo.com/archivo.jpg"
              class="w-full px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
              [class.border-error-500]="form.get('fileUrl')?.invalid && form.get('fileUrl')?.touched"
            />
          </div>
        </div>

        <!-- Row 2: Filename + Mime + DisplayOrder -->
        <div class="grid grid-cols-3 gap-2">
          <div>
            <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">Nombre de archivo</label>
            <input type="text" formControlName="filename" placeholder="producto.jpg"
              class="w-full px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent" />
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">MIME type</label>
            <input type="text" formControlName="mimeType" placeholder="image/jpeg"
              class="w-full px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent" />
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">Orden</label>
            <input type="number" formControlName="displayOrder" min="0"
              class="w-full px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent" />
          </div>
        </div>

        <!-- Row 3: Thumbnail + Description -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <div>
            <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">URL del miniatura</label>
            <input type="text" formControlName="thumbnailUrl" placeholder="https://cdn.ejemplo.com/thumb.jpg"
              class="w-full px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent" />
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">Descripción</label>
            <input type="text" formControlName="description" placeholder="Vista frontal del producto"
              class="w-full px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent" />
          </div>
        </div>

        <!-- Row 4: isPublic checkbox -->
        <div class="flex items-center gap-2">
          <input type="checkbox" formControlName="isPublic" id="isPublicAttach"
            class="h-3.5 w-3.5 rounded border-gray-300 text-brand-500 focus:ring-brand-500/10 dark:border-gray-600 dark:bg-gray-800" />
          <label for="isPublicAttach" class="text-xs text-gray-600 dark:text-gray-400">Accesible públicamente</label>
        </div>

        <!-- Actions -->
        <div class="flex items-center justify-end gap-2 pt-1">
          <button type="button" (click)="cerrarForm()"
            class="px-2.5 py-1 text-xs rounded-md font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600">
            Cancelar
          </button>
          <button type="submit" [disabled]="saving || form.invalid"
            class="px-2.5 py-1 text-xs rounded-md font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
            {{ saving ? 'Guardando...' : (editingId !== null ? 'Actualizar' : 'Crear') }}
          </button>
        </div>
      </form>
    </div>
  }

  <!-- Loading -->
  @if (loading) {
    <div class="flex items-center gap-2 py-4">
      <div class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-brand-500"></div>
      <span class="text-xs text-gray-500 dark:text-gray-400">Cargando adjuntos...</span>
    </div>
  }

  <!-- Attachment list -->
  @if (!loading && !showForm) {
    @if (attachments.length === 0) {
      <div class="flex items-center gap-2 text-gray-400 dark:text-gray-500 py-2">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
        </svg>
        <span class="text-xs">No hay adjuntos registrados</span>
      </div>
    }

    @for (att of attachments; track att.id) {
      <div class="flex items-start justify-between gap-3 p-2.5 rounded-lg border border-gray-100 dark:border-gray-700/50 hover:border-gray-200 dark:hover:border-gray-600 bg-gray-50/50 dark:bg-gray-800/30">
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2 mb-0.5 flex-wrap">
            <span class="text-xs font-semibold text-gray-800 dark:text-white truncate">
              {{ att.filename || att.fileUrl }}
            </span>
            <span class="inline-block px-1.5 py-0.5 rounded text-[10px] font-medium {{ getTypeColor(att.attachmentType) }}">
              {{ getTypeLabel(att.attachmentType) }}
            </span>
            @if (att.isPublic) {
              <span class="inline-block px-1.5 py-0.5 rounded text-[10px] font-medium bg-success-100 text-success-700 dark:bg-success-900/30 dark:text-success-300">
                Público
              </span>
            }
          </div>
          @if (att.description) {
            <p class="text-[11px] text-gray-500 dark:text-gray-400 truncate">{{ att.description }}</p>
          }
          <div class="flex items-center gap-3 mt-1">
            <span class="text-[10px] text-gray-400 dark:text-gray-500">{{ formatSize(att.fileSize) }}</span>
            <span class="text-[10px] text-gray-400 dark:text-gray-500">Subido: {{ formatDate(att.datetimeUploaded) }}</span>
          </div>
        </div>
        <!-- Actions -->
        <div class="flex items-center gap-1 flex-shrink-0">
          <!-- Descargar / abrir -->
          <button type="button" (click)="descargarAdjunto(att)"
            class="rounded p-1 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-900/20 dark:hover:text-brand-400 text-gray-400" title="Descargar / abrir">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
            </svg>
          </button>
          <!-- Reemplazar (solo archivos subidos) -->
          @if (esArchivoSubido(att)) {
            <button type="button" (click)="reemplazarAdjunto(att, replaceInput)" [disabled]="uploadingDoc"
              class="rounded p-1 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 disabled:opacity-40" title="Reemplazar">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
              </svg>
            </button>
          } @else {
            <!-- Edit (adjuntos por URL) -->
            <button type="button" (click)="abrirFormEditar(att)"
              class="rounded p-1 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300" title="Editar">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
              </svg>
            </button>
          }
          <!-- Delete -->
          <button type="button" (click)="eliminar(att)"
            class="rounded p-1 hover:bg-error-50 hover:text-error-600 text-gray-400" title="Eliminar">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
            </svg>
          </button>
        </div>
      </div>
    }
  }
</div>
